import * as store from '@daas-consulting/core-frontend-store';
import { StateToken } from '@ngxs/store';
import { context, feature } from '../remitos.const';
import { RemitosListStateModel as Model } from './remitos-list.state-model';

const name = store.getName({
  context,
  feature,
  section: store.SectionsNames.list,
});
export const stateTokenName = new StateToken<Model>(name);
export const filterFormPath = `${stateTokenName.getName()}.filterForm`;
